import FieldUser_QuickFilterView from "./render/quick-filter-view"
import FieldDropdown_PopoverOptionUser from "./components/option/option-user"
import FieldDropdown from "../dropdown/dropdown"
import FieldConfig from "../../proto/field-config"
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups"
import FieldUser_GlistGroupStandard from "./components/glist-group/standard"
import FieldUser_View from "./render/view"
import FieldUser_ViewSmall from "./render/view-small"
import FieldUser_GlistGroupModern from "./components/glist-group/modern"
import FieldUser_FormValueEmpty from "./components/form/value-empty"
import FieldUser_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldUser_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldUser_ManagementPreview from "./render/management-preview"
import FieldString_ManagementForm from "../string/render/management-form"
import FieldUser_AutomationTriggerForm from "./render/automation/automation-trigger-form"
import FieldUser_AutomationConditionForm from "./render/automation/automation-condition-form"
import FieldUser_AutomationActionForm from "./render/automation/automation-action"
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module"
import mapByUserName from "../../import/normalize/map-user"
import FieldUser_ConditionForm from "./render/condition"
import {ConditionType_Excludes, ConditionType_Includes} from "../../../model2/conditions/condition-types"
import FieldUser_GraphTickLabelView from "./render/graph-tick-label"
import FieldUser_TableCell from "./render/table/table-cell"
import FieldUser_Editable from "./render/editable/editable"
import {FieldFilterType} from "../../proto/types"
import User from "../../../model2/user/user"
import Filter from "../../../manager/filters/manager/filter";
import {FieldUser_filterGetOptions} from "../../conditions/functions/get-filter-options";
import {
    FieldConditionsDropdown_NotAssignedOption,
    FieldConditionsDropdown_NotSetOption
} from "../../conditions/dropdown"
import FieldUser_ViewGroup from "./render/group/group"

const debug = false
// const debug = "FieldUser"

export const ADD_USER = 'add-user'

export default class FieldUser extends FieldDropdown {

    FIELD_DEFAULT_WIDTH                 = 150

    public arValueOption                : boolean       // if true will add action required value option to options list (by default false)
    public arValueOptionLabel           : any       // Label for action required value option
    public assignedToValueOption        : boolean       // if true will add assigned to value option to options list (by default false)
    public assignedToValueOptionLabel   : any       // Label for assigned to value option
    public currentUserValueOption       : boolean       // if true will add current user to value option to options list (by default false) used in automations

    constructor(config:FieldConfig) {

        super(config);

        this.conditionTypes             = [ConditionType_Includes, ConditionType_Excludes]

        this.typeLabel                  = "User"
        this.filterType                 = FieldFilterType.USER
        this.typeGroup                  = GROUP_MISC
        this.typeDescription            = "Company user select field"
        this.icon                       = 'i5-user'
        this.isSearchable               = true
        this.isColorCodingAvailable     = false
        this.isFilterAvailable          = true

        // USER SPECIFIC
        this.noValueOptionLabel         = _.get(config,'noValueOptionLabel','Not assigned')
        this.arValueOption              = _.get(config,'arValueOption',false)
        this.arValueOptionLabel         = _.get(config,'arValueOptionLabel','Action required user')
        this.assignedToValueOption      = _.get(config,'assignedToValueOption',false)
        this.assignedToValueOptionLabel = _.get(config,'assignedToValueOptionLabel','Assigned to user')
        this.currentUserValueOption     = _.get(config,'currentUserValueOption',false)

        // INIT options
        // this.options                    = [] // is set in FieldDropdown
        // this.options CAN BE PASSED in constructor (!!!)
        // this.options CAN BE SET in renderVIEW methods when model passed i.e. projectOwner we need projectID (!)
        if (!config.options || config.options.length < 1) {
            // In shared view we don't have all users gd.users ... so need filter
            this.options = []
            gd.session.companyUsers.filterByCompany(gd.companyId).map((cu:any)=> {
                if (cu.user) {
                    // @ts-ignore
                    this.options.push({
                        value: cu.user.id,
                        label: cu.user.name
                    })
                }
            })
        }

        this.components.PopoverOption       = FieldDropdown_PopoverOptionUser
        this.components.FormValueEmpty      = FieldUser_FormValueEmpty
        this.components.FormValueNotEmpty   = FieldUser_FormValueNotEmpty
        this.components.InlineValueNotEmpty = FieldUser_InlineValueNotEmpty
        this.components.PopoverMenuMore     = null
        this.components.glistGroupModern    = FieldUser_GlistGroupModern
        this.components.glistGroupStandard  = FieldUser_GlistGroupStandard

        this.classes = _.assign(this.classes, {
            PopoverMenu                 : 'min-w-200',
            PopoverMenuScrollContainer  : 'max-h-300',
        })

        _.assign(this.renderComponents, {

            view                    : FieldUser_View,
            viewSmall               : FieldUser_ViewSmall,

            managementPreview       : FieldUser_ManagementPreview,
            managementForm          : FieldString_ManagementForm,

            quickFilterView         : FieldUser_QuickFilterView,

            automationTriggerForm   : FieldUser_AutomationTriggerForm,
            automationConditionForm : FieldUser_AutomationConditionForm,
            automationActionForm    : FieldUser_AutomationActionForm,

            conditionForm           : FieldUser_ConditionForm,
            filterForm              : FieldUser_ConditionForm
        })

        this.renderComponents.graphTickLabelView    = FieldUser_GraphTickLabelView
        this.renderComponents.editable              = FieldUser_Editable
        this.renderComponents.tableCell             = FieldUser_TableCell
        this.renderComponents.viewGroup             = FieldUser_ViewGroup
    }

    // moved from task action required
    _getOption(value:any) {

        if (_.isNil(value)) {
            return false
        }

        switch (value) {

            case '{actionRequiredUserId}':
                return {value: '{actionRequiredUserId}',  icon: "i5-user", label: this.arValueOptionLabel}

            case '{assignedToUserId}':
                return {value: '{assignedToUserId}',      icon: "i5-user", label: this.assignedToValueOptionLabel}

            case '{currentUserId}':
                return {value: '{currentUserId}',         icon: "i5-user", label: 'Current user'}

            default:
                // userId
                // tut mi vsegda pokazivaem based on value (userId)
                const user = gd.session.users.get(value);
                if (user) {
                    return {
                        value: user.id,
                        label: user.name
                    }
                }
                break
        }

        return false;
    }


    getOptions() :Options {
        //special options
        const specialOptions = [];
        if (this.arValueOption)
            specialOptions.push({value: '{actionRequiredUserId}',  icon: "i5-user", label: this.arValueOptionLabel})         // add action required value option if required
        if (this.assignedToValueOption)
            specialOptions.push({value: '{assignedToUserId}',      icon: "i5-user", label: this.assignedToValueOptionLabel}) // add assigned to value option if required
        if (this.currentUserValueOption)
            specialOptions.push({
                value: '{currentUserId}',
                icon: "i5-user",
                label: "Current user"
            })

        // to prevet ts error as this.options can be null
        if (!this.options) {
            return specialOptions
        }

        return specialOptions.concat(this.options);
    }

    getAutomationOptions() {

        let options = _.chain(gd.session.users.models)
            // @ts-ignore
            .filter((u:User)=>{
                const companyUser = gd.session.companyUsers.getByUserId(u.id)
                return companyUser && companyUser.companyRole !== gd.const.companyRole.CLIENT
            }) // filter out client users
            .orderBy(['name'],['asc'])
            .map(m=>({
                value: m.id,
                label: m.name
            }))
            .value()

        const specialOptions = []
        if (this.noValueOption)           specialOptions.push({value: null,                      label: this.noValueOptionLabel})           // add no value option if required
        if (this.arValueOption)           specialOptions.push({value: '{actionRequiredUserId}',  label: this.arValueOptionLabel})           // add action required value option if required
        if (this.assignedToValueOption)   specialOptions.push({value: '{assignedToUserId}',      label: this.assignedToValueOptionLabel})   // add assigned to value option if required
        if (this.currentUserValueOption)
            specialOptions.push({value: '{currentUserId}', icon: "i5-user",         label: 'Current user'})   // add currentUser to value option if required

        // @ts-ignore
        options = specialOptions.concat(options)

        return options
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return mapByUserName(gd.companyId, value)
    }

    groupLabel(value: any): string {
        const option = this._getOption(value)
        return option ? option.label : this.noValueOptionLabel
    }

    getGraphColor(model: any, params: any): string {
        const option = this._getOption(this.getViewValue(model))
        const color = option ? "#"+gd.utils.nameColor(option.label) : gd.skin.colors.chartColors.defaultColor

        debug && console.log(debug, 'getGraphColor', color, option)

        return color
    }

    /*sortValue(value:any) {
        const res: any = _.get(this._getOption(value),'label', null)
        return typeof res === 'string' ? res.toLowerCase() : null
    }*/

    filterGetAllOptions(): Option[] {
        // Ensure all options are included so that any selected options are displayed,
        // even if they are no longer available in the selector popover.
        let allOptions = []
        if (this.showConditionsNotSetOption) {
            allOptions.push(FieldConditionsDropdown_NotAssignedOption)
        }
        const options: any[] = this.getOptions()
        if (options) {
            allOptions = allOptions.concat(options)
        }

        return allOptions
    }

    async filterGetOptions(filter: Filter): Promise<Option[]> {
        return await FieldUser_filterGetOptions(this, filter)
    }
}
